import React from 'react';
import { Avatar } from "../widgets";
import { Dropdown } from "react-bootstrap";

export const compareTwo = (array1, array2) => {
    const added = [], removed = [];
    for (const id of array2) {
        if (array1.indexOf(id) < 0) added.push(id);
    }

    for (const id of array1) {
        if (array2.indexOf(id) < 0) removed.push(id);
    }

    return { added, removed };
}

export const AvatarWithDropdownSelection = (props) => {
    return props.list.map((item) => {
        if (item.list && item.list.length >= 1) {
            let hasDropdownAvatar = false;
            item.list.map(e => e[props.idKeyValue]).forEach(id => {
                if (!props.activeType || props.activeType.indexOf(id) >= 0) hasDropdownAvatar = true;
            })
            return hasDropdownAvatar && <Dropdown key={item[props.idKeyValue]} alignRight={true}>
                <Dropdown.Toggle as="div">
                    <Avatar
                        name={item[props.nameKeyValue].split(" ")[0]}
                        autoTitle="false"
                        color={props.color[item[props.idKeyValue]]}
                        singleLetterAvatar={true}
                        className={`img-avatar avatar-dropdown 
            ${(item.list.filter(e => props.selectedList.indexOf(e[props.idKeyValue]) >= 0).length > 0) ? "selected" : ""}`}
                    />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    {item.list.map(item => {
                        const disable = props.disableList ? props.disableList.indexOf(item[props.idKeyValue]) >= 0 : false;
                        return (!props.activeType || props.activeType.indexOf(item[props.idKeyValue]) >= 0) &&
                            <AvatarItem
                                disable={disable}
                                key={item[props.idKeyValue]}
                                {...{
                                    item, selectedList: props.selectedList, handleSelect: props.handleSelect,
                                    idKeyValue: props.idKeyValue, nameKeyValue: props.nameKeyValue
                                }}
                            />
                    })}
                </Dropdown.Menu>
            </Dropdown>
        }
        else {
            const disable = props.disableList ? props.disableList.indexOf(item[props.idKeyValue]) >= 0 : false;
            return (!props.activeType || props.activeType.indexOf(item[props.idKeyValue]) >= 0) && <Avatar
                key={item[props.idKeyValue]}
                className={`img-avatar ${props.selectedList.indexOf(item[props.idKeyValue]) >= 0 && "selected"} ${disable && "disabled"}`}
                name={item[props.nameKeyValue].split(" ")[0]} color={props.color[item[props.idKeyValue]]} singleLetterAvatar={true}
                {...!disable && { onClick: () => props.handleSelect(item[props.idKeyValue]) }}
            />
        }
    })
}

const AvatarItem = ({ item, selectedList, idKeyValue, nameKeyValue, handleSelect, disable }) =>
    <div key={item[idKeyValue]} className={`dropdown-item-custom`}>
        <label className="d-flex">
            <div style={{ width: "13px" }}>
                {selectedList.indexOf(item[idKeyValue]) >= 0 && <i className={`fa fa-check ${disable && "disabled"}`}
                    aria-hidden="true"></i>}
                {/* <input
                    type="checkbox"
                    disabled={isDisabled(item[idKeyValue])}
                    checked={selectedList.indexOf(e[idKeyValue]) >= 0 }
                    onChange={() => handleSelect(item[idKeyValue])}
                /> */}
            </div>
            <span
                className={`item-text ${selectedList.indexOf(item[idKeyValue]) >= 0 && "checked"} ${disable && "disabled"}`}
                {...!disable && { onClick: () => handleSelect(item[idKeyValue]) }}>{item[nameKeyValue]}
            </span>
        </label>
    </div>;